
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { BiCategory, BiClipboard, BiSolidOffer, BiMessageSquareDetail } from "react-icons/bi";
import { FaMoneyBillWave, FaFileInvoice } from "react-icons/fa";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Collapse } from "reactstrap";
import Logo from "../../images/logo2.png";
// import Logo from "../../images/Free_Sample_By_Wix (2).jpg";
import { MdOutlineVideoSettings, MdPhotoLibrary } from "react-icons/md";
import { VscSettings } from "react-icons/vsc";
import { BsChevronDown, BsImages } from "react-icons/bs";
import { FaUsers } from "react-icons/fa";
import { GiSpellBook } from "react-icons/gi";
import { FaMapLocationDot } from "react-icons/fa6";


const Sidebar = () => {
  const { pathname } = useLocation();
  const [collapse, setCollapse] = useState(false);
  const [masterCollapse, setMasterCollapse] = useState(false);
  const [merchantCollapse, setMerchantCollapse] = useState(false);
  const [ticketInfoCollapse, setTicketInfoCollapse] = useState(false);
  const [blogCollapse, setBlogCollapse] = useState(false);
  const [partnersCollapse, setPartnersCollapse] = useState(false);
  const toggle = () => setCollapse(!collapse);
  const masterToggle = () => setMasterCollapse(!masterCollapse);
  const ticketToggle = () => setTicketInfoCollapse(!ticketInfoCollapse);
  const merchantToggle = () => setMerchantCollapse(!merchantCollapse);
  const blogToggle = () => setBlogCollapse(!blogCollapse);
  const partnersToggle = () => setPartnersCollapse(!partnersCollapse);
  const {
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const collapseClose = () => setCollapse(false);
  const ticketInfoCollapseClose = () => setTicketInfoCollapse(false);
  const masterCollapseClose = () => setMasterCollapse(false);
  const merchantCollapseClose = () => setMerchantCollapse(false);
  const partnersCollapseClose = () => setPartnersCollapse(false);

  const blogCollapseClose = () => setBlogCollapse(false);
  return (
    <Wrapper>
      <div className="d-flex sidebar flex-column  flex-shrink-0 side_bg">

        <nav className="sidenav navbar-vertical navbar-expand-xs navbar-light bg-white fixed-left navbar">
          <div className="col-md-3">
            <div className="logodiv m-0">
              <Link to="/">
                <img img className="img2" src={Logo} alt=""></img>
              </Link>
            </div>
          </div>
        </nav>
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item text-white">
            <Link
              to="/"
              className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname === "/" ? "link_active text-black" : "text-secondary"
                } `}
              aria-current="page"
              onClick={collapseClose}
            >
              <AiOutlineHome className="sideicon" size={22} color="black" />
              <span className="sidetext  ms-3 text-black">Home</span>
            </Link>
          </li>
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PLACES" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/place-list"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("place-list")
                    ? "link_active text-primary"
                    : "text-secondary"
                    }`}
                >
                  <FaMapLocationDot className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Place</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>

              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/home-page"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("home-page")
                    ? "link_active text-primary"
                    : "text-secondary"
                    }`}
                >
                  <FaMapLocationDot className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Home Page</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>

              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/tour-guide"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("tour-guide")
                    ? "link_active text-primary"
                    : "text-secondary"
                    }`}>
                  <FaUsers className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Tour Guide</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "GALLERIES" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/gallery-list"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("gallery-list")
                    ? "link_active text-primary"
                    : "text-secondary"
                    }`}
                >
                  <MdPhotoLibrary className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Gallery</span>
                </Link>
              </li>
            )}
          {/* {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PARTNERS" &&
              item?.permission?.permission === "view"
          ) && (
              <>
                <li role="button" className={`reportdrop border_common nav-item nav-link py-3 ps-3 align-items-center d-flex ${partnersCollapse ? "link_active text-primary" : " text-secondary"}`} onClick={partnersToggle}>
                  <FaUsers className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Partner Registrations</span>
                  <span className="ic" style={{ paddingLeft: "70px" }}><BsChevronDown size={18} color="black" /></span>
                </li>
                <Collapse isOpen={partnersCollapse} className="mt-3">
                  <li className="nav-item border_common">
                    <Link to="/partner-requests" className={`nav-link align-items-center d-flex ${pathname.includes("partner-requests") ? "link_active text-primary" : "text-secondary"}`}>
                      <span className="droptext ms-4 text-black">Partner Requests</span>
                    </Link>
                  </li>
                  <li className="nav-item border_common">
                    <Link to="/pending-partners" className={`nav-link align-items-center d-flex ${pathname.includes("pending-partners") ? "link_active text-primary" : "text-secondary"}`}>
                      <span className="droptext ms-4 text-black">Pending Partners Requests</span>
                    </Link>
                  </li>
                  <li className="nav-item border_common">
                    <Link to="/approved-partners" className={`nav-link align-items-center d-flex ${pathname.includes("approved-partners") ? "link_active text-primary" : "text-secondary"}`}>
                      <span className="droptext ms-4 text-black">Approved/Verified Partners</span>
                    </Link>
                  </li>
                  <li className="nav-item border_common">
                    <Link to="/rejected-partners" className={`nav-link align-items-center d-flex ${pathname.includes("rejected-partners") ? "link_active text-primary" : "text-secondary"}`}>
                      <span className="droptext ms-4 text-black">Rejected Partners</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="#" onClick={partnersCollapseClose}></Link>
                  </li>
                </Collapse>
              </>
            )} */}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PARTNERS" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/partner-requests"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname === "/partner-requests" ? "link_active text-primary" : "text-secondary"}`}
                >
                  <FaUsers className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Partner Requests</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PARTNERS" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/partners"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname === "/partners" ? "link_active text-primary" : "text-secondary"}`}
                >
                  <FaUsers className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Partners</span>
                </Link>
              </li>
            )}
            <li className="nav-item border_common">
                  <Link
                    to="/partner-performance"
                    className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("partner-performance")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <BiCategory className="sideicon" size={22} color="black" />
                    <span className="sidetext ms-3 text-black">Partner Performance</span>
                  </Link>
                </li>
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PARTNERS" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/partner-places"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("partner-places")
                    ? "link_active text-primary"
                    : "text-secondary"
                    }`}
                >
                  <FaMapLocationDot className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Partner Places</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "PARTNERS" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/government-partners"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("government-partners")
                    ? "link_active text-primary"
                    : "text-secondary"
                    }`}
                >
                  <FaUsers className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Government Partner</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "SCHEMES" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common">
                <Link
                  to="/schemes"
                  className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname.includes("schemes")
                    ? "link_active text-primary"
                    : "text-secondary"
                    }`}
                >
                  <GiSpellBook className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Scheme</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "OFFERLIST" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common ">
                <Link
                  to="/offer-list"
                  className={`nav-link py-3 ps-3 ${pathname === "/offer-list"
                    ? "link_active text-primary"
                    : "text-secondary"
                    } align-items-center d-flex`}
                >
                  <BiSolidOffer className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Offer</span>
                </Link>
              </li>
            )}

          <li className="nav-item border_common ">
            <Link
              to="/booking-list"
              className={`nav-link py-3 ps-3 ${pathname === "/booking-list"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BiClipboard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Booking List</span>
            </Link>
          </li>
          <li className="nav-item border_common ">
            <Link
              to="/feedback"
              className={`nav-link py-3 ps-3 ${pathname === "/feedback"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BiMessageSquareDetail className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Feedback</span>
            </Link>
          </li>
          <li className="nav-item border_common ">
            <Link
              to="/online-tickets"
              className={`nav-link py-3 ps-3 ${pathname === "/online-tickets"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BiClipboard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Online Tickets</span>
            </Link>
          </li>
          <li className="nav-item border_common ">
            <Link
              to="/counter-tickets"
              className={`nav-link py-3 ps-3 ${pathname === "/counter-tickets"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BiClipboard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Counter Tickets</span>
            </Link>
          </li>
          <li className="nav-item border_common ">
            <Link
              to="/ticket-history"
              className={`nav-link py-3 ps-3 ${pathname === "/ticket-history"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BiClipboard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Ticket History</span>
            </Link>
          </li>
          <li className="nav-item border_common ">
            <Link
              to="/transaction-history"
              className={`nav-link py-3 ps-3 ${pathname === "/transaction-history"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BiClipboard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Transaction History</span>
            </Link>
          </li>
          <li className="nav-item border_common ">
            <Link
              to="/settlements"
              className={`nav-link py-3 ps-3 ${pathname === "/settlements"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <FaMoneyBillWave className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Settlements</span>
            </Link>
          </li>
          <li className="nav-item border_common ">
            <Link
              to="/invoices"
              className={`nav-link py-3 ps-3 ${pathname === "/invoices"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <FaFileInvoice className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Invoices</span>
            </Link>
          </li>
          <li role="button" className={`reportdrop border_common nav-item nav-link  py-3 ps-3 align-items-center d-flex  ${ticketInfoCollapse ? "link_active text-primary" : " text-secondary"}`} onClick={ticketToggle}>
            <BiCategory className="sideicon" size={22} color="black" />
            <span className="sidetext ms-3 text-black">TicketInfo</span>
            <span className="ic" style={{ paddingLeft: "70px" }}><BsChevronDown size={18} color="black" /></span>
          </li>
          <Collapse isOpen={ticketInfoCollapse} className="mt-3">
            {allowedPermissions?.some?.((item) => item?.permission?.permission === "view") && (
              <li className="nav-item border_common">
                <Link to="/booking-forms" className={`nav-link align-items-center d-flex ${pathname.includes("booking-forms")
                  ? "link_active text-primary" : "text-secondary"}`}>
                  <span className="droptext ms-4 text-black">Booking Ticket Forms</span>
                </Link>
              </li>
            )}
            {allowedPermissions?.some?.((item) => item?.permission?.permission === "view") && (
              <li className="nav-item border_common">
                <Link to="/add-ticket-info" className={`nav-link align-items-center d-flex ${pathname.includes("add-ticket-type")
                  ? "link_active text-primary" : "text-secondary"}`}>
                  <span className="droptext ms-4 text-black">Add Ticket Info</span>
                </Link>
              </li>
            )}
            {allowedPermissions?.some?.((item) => item?.permission?.permission === "view") && (
              <li className="nav-item border_common">
                <Link to="/terms-and-conditoin" className={`nav-link align-items-center d-flex ${pathname.includes("terms-and-conditoin")
                  ? "link_active text-primary" : "text-secondary"}`}>
                  <span className="droptext ms-4 text-black">Terms & Condition</span>
                </Link>
              </li>
            )}
            {allowedPermissions?.some?.((item) => item?.permission?.permission === "view") && (
              <li className="nav-item border_common">
                <Link to="/cancellation-policy" className={`nav-link align-items-center d-flex ${pathname.includes("cancellation-policy")
                  ? "link_active text-primary" : "text-secondary"}`}>
                  <span className="droptext ms-4 text-black">Cancellation Policy</span>
                </Link>
              </li>
            )}
            {allowedPermissions?.some?.((item) => item?.permission?.permission === "view") && (
              <li className="nav-item border_common">
                <Link to="/refund-policy" className={`nav-link align-items-center d-flex ${pathname.includes("refund-policy")
                  ? "link_active text-primary" : "text-secondary"}`}>
                  <span className="droptext ms-4 text-black">Refund Policy</span>
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link to="#" onClick={ticketInfoCollapseClose}></Link>
            </li>
          </Collapse>
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "BANNERLIST" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common ">
                <Link
                  to="/banner-list"
                  className={`nav-link py-3 ps-3 ${pathname === "/banner-list"
                    ? "link_active text-primary"
                    : "text-secondary"
                    } align-items-center d-flex`}
                >
                  <BsImages className="sideicon" size={22} color="black" />
                  <span className="sidetext ms-3 text-black">Banner</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "ORGANIZATIONLIST" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common ">
                <Link
                  to="/organization-list"
                  className={`nav-link py-3 ps-3 ${pathname === "/organization-list"
                    ? "link_active text-primary"
                    : "text-secondary"
                    } align-items-center d-flex`}
                >
                  <MdOutlineVideoSettings
                    className="sideicon"
                    size={22}
                    color="black"
                  />
                  <span className="sidetext ms-3 text-black">Organization</span>
                </Link>
              </li>
            )}
          <li
            role="button"
            className={`reportdrop border_common nav-item nav-link  py-3 ps-3 align-items-center d-flex  ${merchantCollapse ? "link_active text-primary" : " text-secondary"
              }`}
            onClick={merchantToggle}
          >
            <BiCategory className="sideicon" size={22} color="black" />
            <span className="sidetext ms-3 text-black">Merchant</span>
            <span className="ic" style={{ paddingLeft: "80px" }}>
              <BsChevronDown size={18} color="black" />
            </span>
          </li>
          <Collapse isOpen={merchantCollapse} className="mt-3">
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "MERCHANTS" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/merchants"
                    className={`nav-link align-items-center d-flex ${pathname === "/merchants"
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Merchants</span>
                  </Link>
                </li>
              )}

            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "MERCHANTPORTFOLIO" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/portfolio"
                    className={`nav-link align-items-center d-flex ${pathname.includes("portfolio")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Merchant Portfolio</span>
                  </Link>
                </li>
              )}
            <li className="nav-item">
              <Link to="#" onClick={merchantCollapseClose}></Link>
            </li>
          </Collapse>
          <Collapse isOpen={merchantCollapse} className="mt-3">
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "MERCHANTS" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/merchants"
                    className={`nav-link align-items-center d-flex ${pathname === "/merchants"
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Merchants</span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "MERCHANTPORTFOLIO" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/portfolio"
                    className={`nav-link align-items-center d-flex ${pathname.includes("portfolio")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Merchant Portfolio</span>
                  </Link>
                </li>
              )}
            <li className="nav-item">
              <Link to="#" onClick={merchantCollapseClose}></Link>
            </li>
          </Collapse>
          <li
            role="button"
            className={`reportdrop border_common nav-item nav-link  py-3 ps-3 align-items-center d-flex  ${blogCollapse ? "link_active text-primary" : " text-secondary"
              }`}
            onClick={blogToggle}
          >
            <BiCategory className="sideicon" size={22} color="black" />
            <span className="sidetext ms-3 text-black">Blog</span>
            <span className="ic" style={{ paddingLeft: "112px" }}>
              <BsChevronDown size={18} color="black" />
            </span>
          </li>
          <Collapse isOpen={blogCollapse} className="mt-3">
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "BLOGS" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/blogs"
                    className={`nav-link align-items-center d-flex ${pathname === "/blogs"
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Blogs</span>
                  </Link>
                </li>
              )}

            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "BLOGCATEGORIES" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/blog-category"
                    className={`nav-link align-items-center d-flex ${pathname.includes("blog-category")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Blog Category</span>
                  </Link>
                </li>
              )}
            <li className="nav-item">
              <Link to="#" onClick={blogCollapseClose}></Link>
            </li>
          </Collapse>
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "ORGANIZATIONVIDEOLIST" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common ">
                <Link
                  to="/organization-video-list"
                  className={`nav-link py-3 ps-3 ${pathname === "/organization-video-list"
                    ? "link_active text-primary"
                    : "text-secondary"
                    } align-items-center d-flex`}
                >
                  <MdOutlineVideoSettings
                    className="sideicon"
                    size={22}
                    color="black"
                  />
                  <span className="sidetext ms-3 text-black">Organization Videos</span>
                </Link>
              </li>
            )}
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "ORGANIZATIONVIDEOLIST" &&
              item?.permission?.permission === "view"
          ) && (
              <li className="nav-item border_common ">
                <Link
                  to="/check-this-out"
                  className={`nav-link py-3 ps-3 ${pathname === "/check-this-out"
                    ? "link_active text-primary"
                    : "text-secondary"
                    } align-items-center d-flex`}
                >
                  <MdOutlineVideoSettings
                    className="sideicon"
                    size={22}
                    color="black"
                  />
                  <span className="sidetext ms-3 text-black">Check This Out</span>
                </Link>
              </li>
            )}
          <li
            role="button"
            className={`reportdrop border_common nav-item nav-link  py-3 ps-3 align-items-center d-flex  ${masterCollapse ? "link_active text-primary" : " text-secondary"
              }`}
            onClick={masterToggle}
          >

            <BiCategory className="sideicon" size={22} color="black" />
            <span className="sidetext ms-3 text-black">Masters</span>
            <span className="ic" style={{ paddingLeft: "92px" }}>
              <BsChevronDown size={18} color="black" />
            </span>
          </li>
          <Collapse isOpen={masterCollapse} className="mt-3">
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "CATEGORIES" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/category-list"
                    className={`nav-link align-items-center d-flex ${pathname === "/category-list"
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Category</span>
                  </Link>
                </li>
              )}

            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "SUBCATEGORIES" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/subcategory"
                    className={`nav-link align-items-center d-flex ${pathname.includes("subcategory")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Sub Category</span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "SUBSUBCATEGORIES" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/subsubcategory"
                    className={`nav-link align-items-center d-flex ${pathname.includes("subsubcategory")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Sub Sub Category</span>
                  </Link>
                </li>
              )}

            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "SEOLIST" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/seo-lists"
                    className={`nav-link align-items-center d-flex ${pathname.includes("seo-lists")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Seo</span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "STATELIST" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/state-lists"
                    className={`nav-link align-items-center d-flex ${pathname.includes("state-lists")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">State</span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "CITY" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/city"
                    className={`nav-link align-items-center d-flex ${pathname.includes("city")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">City</span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "LOCATION" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/location"
                    className={`nav-link align-items-center d-flex ${pathname.includes("location")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Town</span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "LOCATION" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/destination"
                    className={`nav-link align-items-center d-flex ${pathname.includes("destination")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Destination</span>
                  </Link>
                </li>
              )}
            <li className="nav-item border_common">
              <Link
                to="/review-category"
                className={`nav-link align-items-center d-flex ${pathname.includes("review-category")
                  ? "link_active text-primary"
                  : "text-secondary"
                  }`}
              >
                <span className="droptext ms-4 text-black">Review Category</span>
              </Link>
            </li>
            <li className="nav-item border_common">
              <Link
                to="/inner-line-permission"
                className={`nav-link align-items-center d-flex ${pathname.includes("inner-line-permission")
                  ? "link_active text-primary"
                  : "text-secondary"
                  }`}
              >
                <span className="droptext ms-4 text-black">Inner Line Permission</span>
              </Link>
            </li>
            <li className="nav-item border_common">
              <Link
                to="/state-headers"
                className={`nav-link align-items-center d-flex ${pathname.includes("state-header")
                  ? "link_active text-primary"
                  : "text-secondary"
                  }`}
              >
                <span className="droptext ms-4 text-black">State Header</span>
              </Link>
            </li>
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "EVENTS" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/events"
                    className={`nav-link align-items-center d-flex ${pathname.includes("events")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Events</span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "ADMINUSER" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/enquiries"
                    className={`nav-link align-items-center d-flex ${pathname.includes("enquiries")
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                  >
                    <span className="droptext ms-4 text-black">Enquiries</span>
                  </Link>
                </li>
              )}

            <li className="nav-item">
              <Link to="#" onClick={masterCollapseClose}></Link>
            </li>
          </Collapse>


          <li
            role="button"
            className={`reportdrop border_common nav-item nav-link  py-3 ps-3 align-items-center d-flex  ${collapse ? "link_active text-primary" : " text-secondary"
              }`}
            onClick={toggle}
          >
            <VscSettings className="sideicon" size={22} color="black" />
            <span className="sidetext ms-3 text-black">Settings</span>
            <span className="ic" style={{ paddingLeft: "90px" }}>
              <BsChevronDown size={18} color="black" />
            </span>
          </li>

          <Collapse isOpen={collapse} className="mt-3">
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "ROLE" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/role"
                    className={`nav-link  ${pathname.includes("role")
                      ? "link_active text-primary"
                      : "text-secondary"
                      } align-items-center d-flex`}
                  >
                    <span className="droptext ms-4  text-black">Role</span>
                  </Link>
                </li>
              )}

            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "PERMISSIONS" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/permissions"
                    className={`nav-link ${pathname === "/permissions"
                      ? "link_active text-primary"
                      : "text-secondary"
                      } align-items-center d-flex`}
                  >
                    <span className="droptext ms-4  text-black">Permission</span>
                  </Link>
                </li>
              )}

            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "ASSIGN_PERMISSION" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item border_common">
                  <Link
                    to="/assign-permissions"
                    className={`nav-link  ${pathname === "/assign-permissions"
                      ? "link_active text-primary"
                      : "text-secondary"
                      } align-items-center d-flex`}
                  >
                    <span className="droptext ms-4  text-black">
                      Assign Permission
                    </span>
                  </Link>
                </li>
              )}
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "ADMINUSER" &&
                item?.permission?.permission === "view"
            ) && (
                <li className="nav-item">
                  <Link
                    to="/admin-users"
                    className={`nav-link text-secondary align-items-center d-flex ${pathname === "/admin-users"
                      ? "link_active text-primary"
                      : "text-secondary"
                      }`}
                    onClick={collapseClose}
                  >
                    <span className="ms-4 text-black">Admin Users</span>
                  </Link>
                </li>
              )}
            <li className="nav-item">
              <Link
                to="/qr-code-generator"
                className={`nav-link align-items-center d-flex ${pathname === "/qr-code-generator"
                  ? "link_active text-primary"
                  : "text-secondary"
                  }`}
                onClick={collapseClose}
              >
                <span className="ms-4 text-black">QR Code Generator</span>
              </Link>
            </li>
          </Collapse>
        </ul>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.aside`
  .active {
    font-weight: 700;
  }
  .link_active {
    background: rgba(0, 0, 0, 0.14) !important;
  }
  .sidebar {
    width: 230px;
    background-color: transparent;
    min-height: 100vh;
    padding-top: 10px;
  }

  .side_bg {
    background: white;
  }
  .nav-pills .nav-link {
    background: none;
    border-radius: 0 !important;
  }
`;

export default Sidebar;
